import App from "./App.vue";

import { registerPlugins } from "@/plugins";
// eslint-disable-next-line no-unused-vars
import "@/plugins/axios-config.js";
import "@/plugins/notifications";
import "@/plugins/pusher";
import { createApp } from "vue";
import "vue-global-api";

import { sessionTimer } from "./plugins/session-timer";
import vClickOutside from "./utils/directives/v-click-outside";

const app = createApp(App);

registerPlugins(app);

app.directive("click-outside", vClickOutside);

app.mount("#app");

const timer = sessionTimer();
timer.startTimer();
